// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"e6541c84","239":"e83cb75b","371":"fe99174a","455":"b535cc3d"}[chunkId] + ".chunk.js";
};